// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 41 36" enableBackground="new 0 0 41 36" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M41,4.26C39.48,5,37.87,5.47,36.16,5.69c1.74-1.13,3.08-2.9,3.71-5.02
	c-1.63,1.03-3.43,1.78-5.35,2.21C32.99,1.11,30.8,0,28.38,0c-4.65,0-8.41,4.06-8.41,9.09c0,0.71,0.07,1.4,0.21,2.06
	C13.21,10.79,7,7.16,2.85,1.67c-0.72,1.34-1.13,2.9-1.13,4.57c0,3.15,1.48,5.94,3.74,7.55c-1.38-0.06-2.68-0.44-3.81-1.13v0.13
	c0,4.39,2.9,8.06,6.75,8.91c-0.7,0.21-1.45,0.3-2.22,0.3c-0.54,0-1.05-0.04-1.57-0.16c1.07,3.62,4.18,6.25,7.86,6.31
	c-2.88,2.45-6.51,3.89-10.45,3.89c-0.68,0-1.35-0.04-2.01-0.13C3.72,34.49,8.13,36,12.89,36c15.47,0,23.94-13.85,23.94-25.86
	c0-0.38-0.01-0.77-0.03-1.16C38.44,7.68,39.87,6.08,41,4.26z"/>
</svg>;
};

export default React.memo(Twitter);
